import { Route, Switch } from 'react-router-dom';
import ProcessingRequests from 'src/components/CodeSectionPages/ProcessingRequests';
import PowerOfAssessors from 'src/components/UCA/PowerOfAssessors';
import PropertyTaxDueDate from 'src/components/UCA/PropertyTaxDueDate';
import RefusalToSign from 'src/components/UCA/RefusalToSign';
import { AppealFormProvider } from 'src/contexts/appeal-context';
import { RealPropertyAppealFormProvider } from 'src/contexts/real-property-appeal-context';
import { SettlementFormProvider } from 'src/contexts/settlement-context';
import AppealForm from 'src/pages/AppealForm.jsx';
import Error404Page from 'src/pages/NotFound';
import RealPropertyAppealForm from 'src/pages/RealPropertyAppealForm.jsx';
import SettlementForm from 'src/pages/SettlementForm.jsx';
import 'src/styles/app.css';

function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/personal-property-settlement-form">
          <SettlementFormProvider>
            <SettlementForm />
          </SettlementFormProvider>
        </Route>
        <Route exact path="/personal-property-appeal-form">
          <AppealFormProvider>
            <AppealForm />
          </AppealFormProvider>
        </Route>
        <Route exact path="/real-property-appeal-form">
          <RealPropertyAppealFormProvider>
            <RealPropertyAppealForm />
          </RealPropertyAppealFormProvider>
        </Route>
        <Route exact path="/power-of-assessors">
          <PowerOfAssessors />
        </Route>
        <Route exact path="/property-tax-due-date">
          <PropertyTaxDueDate />
        </Route>
        <Route exact path="/processing-requests">
          <ProcessingRequests />
        </Route>
        <Route exact path="/refusal-to-sign">
          <RefusalToSign />
        </Route>
        <Route path="/*">
          <Error404Page />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
